import React from 'react';
import styles from './index.module.scss';
import cn from 'classnames';

type Props = { className?: string; };

export const IconSuccess: React.FC<Props> = ({
    className,
}) => (
    <span className={cn(styles.iconExternalLink, className)} />
);
